import { User } from '@sdk/users/types/User';

import { MessagePost } from '@web/conversations/types/Message';
import { MessageType } from '@web/conversations/types/MessageType';

type CreateMessageProps = Partial<MessagePost> & { conversationId: number };

export const createMessage = (props: CreateMessageProps): MessagePost => ({
  attachments: [],
  author: {
    id: 1,
  } as User,
  canDelete: true,
  canEdit: true,
  content: '',
  hasFailedToSubmit: false,
  id: +new Date(),
  isDeleted: false,
  isEdited: false,
  parentMessage: null,
  postedAt: new Date(),
  reactions: {},
  type: MessageType.MESSAGE,
  ...props,
});
